//import { forEach } from '@angular/router/src/utils/collection';
import { NgxSpinnerService } from 'ngx-spinner';
import { logbaseService } from './logbase.service';
import { GlobalconfigService } from './../common/globalConfig.service';
//import { JwtHelper } from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Utils } from './utils';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, tap } from 'rxjs';

@Injectable()
export class AuthService {

  validToken: boolean;
  loginDetails: any;
  loginUserDetails: any;
  roleArray=[];
  jwt = new JwtHelperService();
  refresh_url=environment.refresh_token_url;

  BASE_URL = '';
  LOGIN_REDIRECT_URL = environment.loginUrl_SSO;
  LOGOUT_REDIRECT_URL = environment.logoutUrl_SSO;

  constructor(private userService: logbaseService,private globalserconfig : GlobalconfigService, private logbaseService: logbaseService,
    private router: Router, private spinner: NgxSpinnerService,private http:HttpClient) { 
      console.log("global config 1",this.globalserconfig)
      this.BASE_URL = this.globalserconfig.baseApiUrl;
      console.log("base api url",this.BASE_URL)
     }

  public loginFromToken(tokenExternal1,tokenExternal3) {

    if (!tokenExternal1) return false;

    this.validToken = this.validateToken(tokenExternal1); // Check wether token is valid or not
    if (!this.validToken) return this.redirectToDaimler("login"); // Token is not valid then redirect to Diamler sso
    if (this.clearLocalData()) { 
      //localStorage.setItem('userToken', tokenExternal);
      this.updateUserDetails(tokenExternal1,tokenExternal3);
        //localStorage.setItem('userToken', tokenExternal);
    }
  }

  isAuthenticated() {    
    if (localStorage.getItem('userToken')) {
      return (
        localStorage.getItem('userDetails') &&
        localStorage.getItem('userToken') != null &&
        !this.jwt.isTokenExpired(localStorage.getItem('userToken'))
      );
    }
    return false;
  }

  clearLocalData() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('currentUser');
   // localStorage.removeItem("currentUser");
    //localStorage.removeItem("userDetails");
    //localStorage.removeItem('userToken')
    localStorage.removeItem("overAllPackageIDStatus");
    localStorage.removeItem("packageID");
    localStorage.removeItem("tempSupItem");
    localStorage.removeItem("usersData");
    localStorage.removeItem("partsData");
    localStorage.removeItem('cacheUser')
    //localStorage.removeItem(this.loggedInUser);
    localStorage.removeItem('todoSuppCode');
    localStorage.removeItem('partStatusSuppCode');
    localStorage.removeItem('partStatusLineNo');
    localStorage.removeItem('todoLineNo');
    return true;
  }

  public validateToken(tokenExternal) {
    if (!this.jwt.isTokenExpired(tokenExternal)) return true;
    else return false;
  }

  public redirectToDaimler(status) {
    let redirectExternal=(status=="login")?this.LOGIN_REDIRECT_URL:this.LOGOUT_REDIRECT_URL;
    this.clearLocalData();
    window.open(redirectExternal, "_self");
    
  }

  updateUserDetails(tokenExternal1,tokenExternal3){ 
  
    localStorage.setItem('id_token',tokenExternal1)
    localStorage.setItem('refresh_token',tokenExternal3)

    const decodedExternalToken = this.jwt.decodeToken(tokenExternal1);
    let userRolesFromToken = Array.isArray(decodedExternalToken.entitlements)
  ? decodedExternalToken.entitlements
      .filter(entitlement => !/^LOGBASE\.lb_supplier\$S-\d+$/.test(entitlement)) // Filter out matching entitlements
      .map(entitlement => entitlement.replace("LOGBASE.", "")) // Map and remove "LOGBASE."
  : [];



    //let userIdDynamic=1;
    let uid=decodedExternalToken.uid
    this.userService.getRolesFromApi(uid).subscribe(result => {
      const newRoles = result.response.filter(role => !userRolesFromToken.includes(role));
      userRolesFromToken = userRolesFromToken.concat(newRoles);
      userRolesFromToken = userRolesFromToken.filter(role => !role.includes("lb_supplier$S-"));
      this.roleArray=userRolesFromToken;
    });


    if (!decodedExternalToken) return; 
    
    if(userRolesFromToken==undefined || userRolesFromToken==null){
      this.spinner.hide();
      Utils.alertWithMesssgeUpdated("You are not authorized to access..!");
      setTimeout(() => { this.logout()}, 5000);
      return;

    }
    
  
  
    let roledetail: any;
    
    
    if(null!=userRolesFromToken && undefined !=userRolesFromToken && userRolesFromToken.length>=1)
    {
      userRolesFromToken.forEach(obj=>{
        if(obj.includes("lb"))
        {
          roledetail=obj;
          this.roleArray.push(obj);
        }
      })
    }
     if (userRolesFromToken.length == 0 || roledetail == undefined || roledetail == null) {
      this.spinner.hide();
     // Utils.alertWithMesssge("You are not authorized to access..!", "error");
     Utils.alertWithMesssgeUpdated("You are not authorized to access..!");
      setTimeout(() => { this.logout(); this.spinner.show()}, 5000);
      return;
    }  
    let username=uid
    let loginData = {
       loginId: username,
       userRoleName: roledetail
        //loginId: "suppliernov",
        //userRoleName: "lb_supplier"
       
      }
      

    this.logbaseService.getUserLoginDetails(loginData).subscribe(result=>{

      this.loginDetails=result;

      if (this.loginDetails.status.statusCode == 1) {
        this.loginUserDetails=this.loginDetails.response;
        localStorage.setItem('currentUser', JSON.stringify(this.loginDetails.response.loginId));
        localStorage.setItem('userDetails', JSON.stringify(this.loginDetails.response));
        localStorage.setItem('userRoleArray', JSON.stringify(this.roleArray));
        console.log("navigating to dashboard")
        this.router.navigate(["/dashboard"]);
      }
      /*if(this.loginDetails.status.statusCode == 1){
        this.router.navigate(["/dashboard"]);
      } */
      else if(this.loginDetails.status.statusCode == -1 && this.loginDetails.status.displayMessage == 'AUTHORIZATION FAILED'){
        this.spinner.hide();
        Utils.alertWithMesssgeUpdated("You are not authorized to access..!");
      setTimeout(() => { this.logout(); this.spinner.show()}, 5000);
      return;
      }

    })

  }
  public getRefreshtokenStorage() {

    let params = new HttpParams();
    params = params.append('code', localStorage.getItem('refresh_token'));
    params = params.append('isRefresh', 'true');
    params = params.delete('user_key');
  
    // params = params.append('shift', shiftType);
    // return this.http.get<ApiResponse<ProductionProgress>>(`${this.BASE_URL}/prodProgress`,{params: params})
  
    return this.http.get<any>(this.refresh_url, { params }).pipe(
      tap((response) => {
        // Update tokens in local storage
        this.updateTokens(response);
      })
    );
  }
  updateTokens(tokens){
    localStorage.setItem('access_token', tokens.accessToken);
    localStorage.setItem('id_token', tokens.idToken);
    localStorage.setItem('refresh_token', tokens.refreshCode);
  
  }
  public getRefreshtoken() {
  
    let params = new HttpParams();
    params = params.append('shift', localStorage.getItem('refres_token'));
    // params = params.append('shift', shiftType);
    // return this.http.get<ApiResponse<ProductionProgress>>(`${this.BASE_URL}/prodProgress`,{params: params})
  
    return this.http
      .get<any>(environment.refresh_token_url, {params: params})
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  public logout() {     
    this.redirectToDaimler("logout");
  }


}
